<div class="dialog-container">
	<div class="dialog-header">
		<h2>Remover Usuário</h2>
		<button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
			<mat-icon matTooltip="Fechar diálogo">close</mat-icon>
		</button>
	</div>

	<div class="dialog-content">
				<app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>
			<h3>Tem certeza que deseja remover o usuário <b>{{data.usuario.dscNome}}</b> ({{data.usuario.dscLogin}})?</h3>
			<p><strong>
				Essa ação não pode ser desfeita.
			</strong>
		</p>
		<!-- {{ data.usuario | json }} -->
			<div class="row">
				<div class="col d-flex justify-content-end gap-2">
					<button mat-flat-button color="accent" (click)="onConfirmar()">
						<mat-icon>check</mat-icon> Confirmar
					</button>
					<button mat-flat-button (click)="onCancelar()">
						<mat-icon>close</mat-icon> Cancelar
					</button>
				</div>
			</div>
	</div>




</div>
